<template>
    <button :class="buttonType" :disabled="disabled || isLoading">
        {{ text }}
        <svg class="spinner" viewBox="0 0 50 50" v-if="isLoading">
            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
        </svg>
    </button>
</template>

<script>
export default {
    name: 'appButtonSecondary',
    props: {
        text: String,
        buttonType: String,
        disabled: {
            default: false,
            type: Boolean
        },
        isLoading: {
            default: false,
            type: Boolean
        },
    }
}
</script>

<style scoped lang="scss">
    @import "@/assets/scss/components/ui/buttons/appButtonTemplate";
</style>
